function BlueTickIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.7932 11.4799L13.8592 3.41394L14.9202 4.47494L5.7932 13.6009L1.2002 9.00794L2.2602 7.94694L5.7932 11.4799Z"
        fill="#1677FF"
      />
    </svg>
  );
}

export default BlueTickIcon;
